import React from 'react';
import { Tree } from 'antd';

const SbTree = (props) => <Tree {...props} />;

export default SbTree;
